export const content = {
  columnLabels: {
    fehler: 'Fehler',
  },
  buttons: {
    inPlanung: 'Auf "In Planung" setzen',
    abgeschlossen: 'Auf "Planung abgeschlossen" setzen',
    freigegeben: 'Auf "Planung freigegeben" setzen',
    imAusschreibungsportal: 'In Ausschreibung übertragen',
  },
  keineDurchgaengeAuswahl: 'Keine Durchgänge ausgewählt.',
  keineDurchgaengeAenderung: 'Keine Durchgänge geändert.',
  statuswechselFehler: 'Ein Fehler ist beim Statuswechsel der Durchgänge aufgetreten.',
} as const;
